import { useCallback, useState } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import logo from "../../assets/logo.png";
import {
  Divider,
  Drawer,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import { useNavigate } from "react-router";
import MenuIcon from "../CustomIcons/MenuIcon";
import HomeSharpIcon from "@mui/icons-material/HomeSharp";
import CallIcon from "@mui/icons-material/Call";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import InfoIcon from "@mui/icons-material/Info";
const pages = [
  { title: "Home", navigateTo: "/", icon: <HomeSharpIcon /> },
  { title: "About", navigateTo: "/about", icon: <InfoIcon /> },
  { title: "Services", navigateTo: "/services", icon: <BusinessCenterIcon /> },
  {
    title: "Contact Us",
    navigateTo: "/contact-us",
    backgroundColor: "#164B7C",
    icon: <CallIcon />,
  },
];

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: "400",
  },
  icons: {
    color: "#282828",
    width: "30px",
    height: "33px",
  },
}));

const Navbar = () => {
  const classes = useStyles();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const navigate = useNavigate();

  const toggleDrawer = useCallback(() => {
    setDrawerOpen(!drawerOpen);
  }, [setDrawerOpen, drawerOpen]);

  const onDrawerClick = useCallback(
    (page) => {
      toggleDrawer();
      navigate(page.navigateTo);
    },
    [toggleDrawer, navigate]
  );

  return (
    <AppBar
      position="sticky"
      sx={{
        backgroundColor: "white",
        boxShadow: "none",
        pl: { xs: 1, md: 6 },
        pr: { xs: 1, md: 6 },
        top: 0,
        zIndex: 1100,
      }}
    >
      <Container maxWidth="xl">
        <Toolbar>
          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              width: "15%",
              cursor: "pointer",
            }}
            onClick={() => navigate("/")}
          >
            <img
              alt="home"
              src={logo}
              style={{
                width: "100%",
                height: "auto",
              }}
            />
          </Box>
          <Box
            sx={{
              display: { xs: "flex", md: "none" },
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                width: "60%",
                cursor: "pointer",
                marginTop: 3,
              }}
              onClick={() => navigate("/")}
            >
              <img
                alt="home"
                src={logo}
                style={{
                  width: "100%",
                  height: "auto",
                }}
              />
            </Box>
            <Box>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={toggleDrawer}
                color="black"
              >
                <MenuIcon />
              </IconButton>
            </Box>
          </Box>

          <Box
            sx={{
              flexGrow: 1,
              display: { xs: "none", md: "flex" },
              justifyContent: "flex-end",
              flexDirection: "row",
              columnGap: 5,
            }}
          >
            {pages.map((page) => (
              <Button
                key={page}
                onClick={() => navigate(page.navigateTo)}
                sx={{ my: 2, color: "white", display: "block" }}
                style={{
                  fontFamily: "Montserrat",
                  fontStyle: "normal",
                  fontWeight: 500,
                  fontSize: "20px",
                  lineHeight: "24px",
                  letterSpacing: "-1.5px",
                  color: page.backgroundColor ? "#FFFFFF" : "#000000",
                  backgroundColor: page.backgroundColor,
                  textTransform: "none",
                  borderRadius: "10px",
                }}
              >
                {page.title}
              </Button>
            ))}
          </Box>
        </Toolbar>
      </Container>

      <Drawer
        anchor="left"
        open={drawerOpen}
        onClose={toggleDrawer}
        className={classes.drawer}
        sx={{
          display: { xs: "block", md: "none" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: "80%",
          },
        }}
      >
        <Box
          sx={{
            width: "60%",
            cursor: "pointer",
            my: 2,
            ml: 3,
          }}
          onClick={() => navigate("/")}
        >
          <img
            alt="home"
            src={logo}
            style={{
              width: "100%",
              height: "auto",
              display: "flex",
              alignItems: "center",
            }}
          />{" "}
        </Box>{" "}
        {pages.map((page) => (
          <ListItem button onClick={() => onDrawerClick(page)}>
            <ListItemText
              primaryTypographyProps={{
                style: {
                  fontFamily: "Montserrat",
                  fontWeight: 500,
                  fontSize: 20,
                  color: "#282828",
                  display: "flex",
                  flexDirection: "row",
                  columnGap: 10,
                  alignItems: "center",
                },
              }}
            >
              {page.icon} {page.title}
            </ListItemText>
          </ListItem>
        ))}
        <Divider />
        <Typography variant="body2" sx={{ textAlign: "center", marginTop: 2 }}>
          © {new Date().getFullYear()} Design | Powered by El Deeb
        </Typography>
      </Drawer>
    </AppBar>
  );
};
export default Navbar;
